// extracted by mini-css-extract-plugin
module.exports = {"landingPageSearch":"landingPageSearch_landingPageSearch__7L3aI","categoriesWrapper":"landingPageSearch_categoriesWrapper__hGzt6"};